const BASE_URL = '/nps/feedbacks';

export function fetchActiveCampaign() {
    return Hop.get(`${BASE_URL}/user/active`).then((response) => response.json());
}

function postFeedback(feedbackRequest) {
    return Hop.post(BASE_URL, JSON.stringify(feedbackRequest), {'Content-Type': 'application/json'});
}

export function postDismiss() {
    return postFeedback({
        responsePath: window.location.pathname,
        isDismissal: true,
    });
}

export function postAnswer(score, comment) {
    return postFeedback({
        score,
        comment,
        responsePath: window.location.pathname,
        isDismissal: false,
    });
}
